import { Box, Container, Grid, Typography } from "@mui/material";
import CenteredWrapper from "@entrilia/shared/components/CenteredWrapper";
import ScrollableFlexContainer from "@entrilia/shared/components/ScrollableFlexContainer";
import type { VideoLibraryCategory, VideoLibraryItem } from "../../../api/types/videoLibraryTypes";
import VideoCard from "./VideoCard";

interface Props {
  items: VideoLibraryItem[];
  allCategories: VideoLibraryCategory[];
  hasPermissionsToManageVideos: boolean;
  onEditVideo: (videoInfo: VideoLibraryItem) => void;
  onDeleteVideo: (videoInfo: VideoLibraryItem) => void;
}

const VideoLibraryContainer = ({
  items,
  allCategories,
  hasPermissionsToManageVideos,
  onEditVideo,
  onDeleteVideo,
}: Props) => {
  if (items.length === 0) {
    return (
      <Box sx={{ position: "relative", flex: 1 }}>
        <CenteredWrapper>
          <Typography color="textSecondary">No videos</Typography>
        </CenteredWrapper>
      </Box>
    );
  }

  return (
    <ScrollableFlexContainer>
      <Container maxWidth={false} disableGutters>
        <Grid container spacing={3} columns={60} sx={{ width: "100%" }}>
          {items.map((item, index) => (
            <Grid key={item.id} size={{ xl: 15, lg: 20, md: 30, sm: 30, xs: 60 }}>
              <VideoCard
                videoInfo={item}
                allCategories={allCategories}
                thumbnailIndex={index}
                hasPermissionsToManageVideos={hasPermissionsToManageVideos}
                onEdit={onEditVideo}
                onDelete={onDeleteVideo}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </ScrollableFlexContainer>
  );
};

export default VideoLibraryContainer;
